import { render, staticRenderFns } from "./Tegninger.vue?vue&type=template&id=2fb2b081&"
import script from "./Tegninger.vue?vue&type=script&lang=js&"
export * from "./Tegninger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports